module.exports = __webpack_public_path__ + "71b0f94a1adbde23d558535129d319ee.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/MU.svg
// module id = Iqum
// module chunks = 0